import { render, staticRenderFns } from "./FamilyList.vue?vue&type=template&id=0ccf51ff&scoped=true&lang=pug"
import script from "./FamilyList.vue?vue&type=script&lang=ts"
export * from "./FamilyList.vue?vue&type=script&lang=ts"
import style0 from "./FamilyList.vue?vue&type=style&index=0&id=0ccf51ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccf51ff",
  null
  
)

export default component.exports